var $ = require('jquery');

module.exports = {
    init: function () {
        $('.scroll-to').click(function(evt){
            evt.preventDefault();
            var target = $(this).attr('href');
            if(target == '#next'){
                var target = $(this).parents('.block').next().get(0);
            }
            var offset = $(target).offset().top - $('header.header').outerHeight();
            $('html, body').animate({ scrollTop: offset }, 1000);
        });
    }
}